// a redux reducer for the ErrorMessages interface

import { ErrorMessages } from "../models/refsixState";
import { POP_ERROR_MESSAGE, PUSH_ERROR_MESSAGE } from "../actions/types";

const initialState: ErrorMessages = {
    messages: [],
};

export function errorMessagesReducer(
    state: ErrorMessages = initialState,
    action: any
) {
    switch (action.type) {
        case PUSH_ERROR_MESSAGE:
            return {
                ...state,
                messages: [...state.messages, action.message],
            };
        case POP_ERROR_MESSAGE:
            return {
                ...state,
                messages:
                    state.messages.length > 0
                        ? state.messages.slice(1)
                        : state.messages,
            };
        default:
            return state;
    }
}
